<template>
  <div>
    <div class="head-nav d-aligncnter">
      <div class="nav-left"></div>
      <div class="nav-title d-allcenter overflow">校外人员场馆预约</div>
      <div class="nav-right"></div>
    </div>
    <div class="content">
      <div class="weight">常用功能</div>
      <div class="d-around">
        <div class="d-column model d-allcenter" @click="pageToAdd">
          <img src="@/assets/img/appointment/stadium.svg" />
          <div class="">场馆预约</div>
        </div>
        <div class="d-column model d-allcenter" @click="pageToActul">
          <img src="@/assets/img/appointment/pie.svg" />
          <div class="">场地实况</div>
        </div>
        <div class="d-column model d-allcenter" @click="pageToOrder">
          <img src="@/assets/img/appointment/cart.svg" />
          <div class="">我的预约</div>
        </div>
        <div class="d-column model d-allcenter" @click="pageToFace">
          <img src="@/assets/img/appointment/scan.svg" />
          <div class="">人脸录入</div>
        </div>
      </div>

      <div class="weight mt-16">场馆介绍</div>
      <div
        class="d-allcenter d-wrap"
        style="margin-top: 8px; height: calc(100vh - 290px); overflow: scroll"
        @scroll="handleScroll"
        ref="myscrollindex"
      >
        <div
          class="venues-each"
          @click="pageToInfo(item)"
          v-for="(item, index) in currVenuesList"
          :key="'currVenuesList_' + index"
        >
          <div class="bg-color"></div>
          <div class="venues-bg" :style="{ backgroundImage: 'url(' + item.img + ')' }"></div>
          <!-- <img :src="item.img" /> -->
          <div class="venues-info">
            <div class="weight">{{ item.name }}</div>
            <div>——</div>
            <!-- <div>篮球1</div>
            <div>排球4</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currTab: 0,
      currVenuesList: [],
      keepScroll: '',
    }
  },
  props: ['venuesList'],
  watch: {
    venuesList: {
      handler: function () {
        this.currVenuesList = this.venuesList
      },
      deep: true,
    },
  },
  mounted() {
    this.currVenuesList = this.venuesList
    console.log('this.currVenuesList：', this.currVenuesList)
    // window.addEventListener('scroll', this.handleScroll)
    this.$on('keepDataIndex', function () {
      this.keepDataIndex()
    })
  },
  methods: {
    keepDataIndex() {
      this.$refs.myscrollindex.scrollTop = this.keepScroll
    },
    handleScroll() {
      this.keepScroll = this.$refs.myscrollindex.scrollTop
    },
    pageToOrder() {
      this.$parent.changeTab(1)
      this.$emit('getMyConferenceData')
    },
    pageToFace() {
      this.$router.push({ path: '/appointment/takeface' })
    },
    pageToInfo(item) {
      this.$router.push({
        path: '/appointment/venuesinfo',
        query: {
          venues: item.id,
        },
      })
    },
    pageToActul() {
      this.$router.push({ path: '/appointment/actully' })
    },
    pageToAdd() {
      this.$router.push({ path: '/appointment/addorder' })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';
.model {
  width: 72px;
  height: 72px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 2.801px 8.403px 31.122px -4.046px rgba(22, 52, 80, 0.1);
  margin-top: 16px;
  color: #464646;
}
.mt-16 {
  margin-top: 16px;
}
.venues-each {
  width: 347px;
  height: 192px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  margin: 8px;
  .bg-color {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(90deg, #002417 0.15%, rgba(0, 122, 77, 0) 54.73%);
  }
  img {
    width: 100%;
  }
}
.venues-info {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 99;
  color: #fff;
  font-size: 14px;
}
.venues-bg {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
